import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { engagementTypes, industryExperience, regulatoryEnvironments } from '../data/profile';
export function Experiences() {
  return <PageShell path="/experiences" data-id="element-329" data-mp="2d4dg35mcvn7i">
      <section id="industry" className="bg-white py-20 lg:py-24" aria-labelledby="industry-heading" data-id="element-330" data-mp="2d5eyxw9m5dzs">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-331" data-mp="30v9dci9kzam5">
          <div id="industry-heading" data-id="element-332" data-mp="35tu3fov4cdwv">
            <SectionHeading eyebrow="Industry Exposure" title="Where she has operated" description="Four sectors, each with a different definition of what an unacceptable data failure looks like." data-id="element-333" data-mp="35ssoh9azf79v" />
          </div>

          <ul className="mt-12 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 md:grid-cols-2" data-id="element-334" data-mp="3jsaic334xaq3">
            {industryExperience.map(industry => <li key={industry.sector} className="grid grid-rows-[auto_auto_1fr_auto] bg-white p-8 lg:p-10" data-id="element-335" data-mp="3v0pwwlebav1e">
                <p className="font-sans text-xs font-semibold uppercase tracking-[0.16em] text-gold-600" data-id="element-336" data-mp="3q3pseex420ce">
                  {industry.years}
                </p>
                <h3 className="mt-3 min-h-[3.5rem] font-display text-xl font-bold leading-snug tracking-tight text-navy-900" data-id="element-337" data-mp="3uevup9axua2">
                  {industry.sector}
                </h3>
                <p className="mt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-338" data-mp="dl123sv4p8g3">
                  {industry.focus}
                </p>
                <ul className="flex flex-wrap gap-2 pt-6" data-id="element-339" data-mp="rjr2pih5pq97">
                  {industry.exposure.map(item => <li key={item} className="whitespace-nowrap border border-platinum-200 bg-platinum-100 px-2.5 py-1 font-sans text-xs font-semibold text-charcoal-700" data-id="element-340" data-mp="mj38yp1jmvba">
                      {item}
                    </li>)}
                </ul>
              </li>)}
          </ul>
        </div>
      </section>

      <section id="regulatory" className="bg-navy-900 py-20 lg:py-24" aria-labelledby="regulatory-heading" data-id="element-341" data-mp="xac4dmsd8ogq">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-342" data-mp="1695wp0ynysoh">
          <div className="lg:col-span-5" data-id="element-343" data-mp="1b8ifnamezfls">
            <div id="regulatory-heading" data-id="element-344" data-mp="1b7qyh4tkdkf1">
              <SectionHeading eyebrow="Regulatory Environments" title="Supervisory regimes worked within" description="Direct accountability for evidence and remediation under each of the following." tone="dark" data-id="element-345" data-mp="1g7d9d7lx6oko" />
            </div>
          </div>

          <ul className="space-y-px bg-white/10 lg:col-span-7" data-id="element-346" data-mp="1tzjelynjbb5c">
            {regulatoryEnvironments.map(regulator => <li key={regulator.name} className="flex items-start gap-5 bg-navy-900 py-6" data-id="element-347" data-mp="1yymmdquwfvh0">
                <ShieldCheckIcon className="mt-1 h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-348" data-mp="292kv2sk6hdy4" />
                <div data-id="element-349" data-mp="241x6edjf9972">
                  <p className="font-display text-base font-bold text-white" data-id="element-350" data-mp="241dnati1cerg">{regulator.name}</p>
                  <p className="mt-2 font-sans text-sm leading-relaxed text-platinum-300" data-id="element-351" data-mp="1z3vmjqe695uj">
                    {regulator.detail}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>
      </section>

      <section id="engagement" className="bg-platinum-100 py-20 lg:py-24" aria-labelledby="engagement-heading" data-id="element-352" data-mp="2msocn6844jh8">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-353" data-mp="2i1oi27mgudhw">
          <div id="engagement-heading" data-id="element-354" data-mp="2e0upv21zqcj7">
            <SectionHeading eyebrow="Engagement Types" title="The shapes of work she has led" data-id="element-355" data-mp="2dzthx6g9u65p" />
          </div>
          <ul className="mt-10 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 sm:grid-cols-2 lg:grid-cols-3" data-id="element-356" data-mp="3aklk6l4j4pcj">
            {engagementTypes.map(type => <li key={type} className="bg-white px-6 py-7 font-display text-base font-semibold leading-snug text-navy-900" data-id="element-357" data-mp="2q8pxa8p3pgrl">
                {type}
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}